<script setup lang="ts">
import { CheckboxItem } from '@shared/ui/checkbox'

import { useTutorApplicationStore } from '../../model/store'
import { useAcceptDataProcessingTerms } from '../../model/legal-agreements/accept-data-processing-terms.hooks'

defineOptions({
  name: 'AcceptDataProcessingTerms',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setAcceptDataProcessingTerms,
} = useAcceptDataProcessingTerms()

</script>

<template>
  <CheckboxItem
    :label="label"
    required
    :checked="tutorApplicationStore.form.acceptDataProcessingTerms"
    :mode="mode"
    @click="setAcceptDataProcessingTerms"
  />
</template>
